import React from 'react';
import styles from './Footer.module.css';

const footer = () => (
  <footer className={`${styles.Footer} "border-t p-4 mt-4"`}>
    <p className="text-center text-lg">Footer</p>
  </footer>
)

export default footer;